import { HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import {
  OCC_HTTP_TOKEN,
  OccProductSearchAdapter,
  PRODUCT_SEARCH_PAGE_NORMALIZER,
  ProductSearchPage,
  SearchConfig,
} from '@spartacus/core';
import { Observable } from 'rxjs';

@Injectable()
export class CustomOccProductSearch extends OccProductSearchAdapter {
  readonly CUSTOM_SEARCH_CONFIG: SearchConfig = {
    pageSize: 20,
  };

  override search(query: string, searchConfig = { pageSize: 20 }): Observable<ProductSearchPage> {
    const context = new HttpContext().set(OCC_HTTP_TOKEN, {
      sendUserIdAsHeader: true,
    });

    let customSearchConfig = {
      ...searchConfig,
      ...this.CUSTOM_SEARCH_CONFIG,
    };

    return this.http
      .get(this.getSearchEndpoint(query, customSearchConfig), { context })
      .pipe(this.converter.pipeable(PRODUCT_SEARCH_PAGE_NORMALIZER));
  }
}
